import React from 'react';

import { SnackbarProvider } from 'notistack';

import { ThemeWrapper } from 'src/components/theme';

import { GlobalStateProvider } from '../GlobalStateProvider';
import { ThemeProvider } from '../ThemeProvider';

export const RootProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <ThemeProvider>
      <ThemeWrapper>
        <SnackbarProvider domRoot={notificationsDomRoot} maxSnack={3}>
          <GlobalStateProvider>{children}</GlobalStateProvider>
        </SnackbarProvider>
      </ThemeWrapper>
    </ThemeProvider>
  );
};

const notificationsDomRoot = document.getElementById('app-notifications') || undefined;
